<template>
  <v-sheet>
    <v-row class="mt-3">
      <v-col>
        <v-text-field
          v-model="email"
          type="email"
          label="E-mail"
          required
          outlined
          prepend-icon="mdi-at"
          :rules="rules.email"
          :disabled="loading"
        >
        </v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          prepend-icon="mdi-lock"
          :rules="rules.password"
          :append-icon="passShow ? 'mdi-eye-off' : 'mdi-eye'"
          required
          outlined
          hint="At least 8 characters & one letters or numbers"
          :disabled="loading"
          :type="passShow ? 'text' : 'password'"
          @click:append="passShow = !passShow"
        >
        </v-text-field>
        <p
          class="error--text text-center text-body-2 ma-0"
          v-if="error.type == 'password'"
        >
          {{ error.msg }}
        </p>
        <v-btn
          block
          bottom
          large
          color="blue"
          :disabled="!valid"
          :dark="valid"
          :loading="loading"
          @click="login"
        >
          <v-icon small class="mr-3">mdi-lock-open-variant</v-icon> Login
        </v-btn>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script lang="ts">
import { Msg } from "@/types";
import { v4 } from "uuid";
import Vue from "vue";
import { validations } from "../utils";
const email = new RegExp(
  "^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9]).[a-z0-9]{2,10}(?:.[a-z]{2,10})?$"
);
const password = {
  strong: new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
  ),
  medium: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"),
  easy: new RegExp("^(?=.*[a-z])(?=.*[0-9])(?=.{8,})"),
};

export default Vue.extend({
  name: "LoginComp",
  data() {
    return {
      rules: {
        email: [validations.email],
        password: [validations.password.len, validations.password.strength],
      },
      email: "",
      password: "",
      passShow: false,
      loading: false,
      error: { msg: "", type: "" },
    };
  },
  methods: {
    validate(field: string, type: string): boolean {
      let valid = false;
      switch (type) {
        case "email":
          valid = email.test(field);
          break;
        case "password":
          valid = password.medium.test(field);
          break;

        default:
          break;
      }
      return valid;
    },
    async login() {
      this.error = {};
      this.loading = true;
      const result = await this.$store.dispatch("Users/login", {
        email: this.email,
        password: this.password,
      });
      const { id, name } = result;
      if (id) {
        this.$router.push("/");
        const msg: Msg = {
          id: v4(),
          icon: "account",
          type: "success",
          content: `Welcome Back <strong>${name}</strong> :)`,
          dismissible: true,
          timeout: 2000,
        };
        this.$store.dispatch("popMsg", msg);
      } else {
        // console.log(result);

        this.error = result;
        setTimeout(() => {
          this.error = {};
        }, 3000);
      }
      this.loading = false;
    },
  },
  computed: {
    valid(): boolean {
      return (
        this.validate(this.email, "email") &&
        this.validate(this.password, "password")
      );
    },
  },
});
</script>
